import React, { Component } from "react";
import PropTypes from "prop-types";
import { AddonItem } from "./";
import styles from "./styles.less";

class AddonsList extends Component {
  render() {
    const { addons, titles, onAddonRemove } = this.props;

    if (addons.length == 0) return <div />;

    const toRender = addons.map(a => {
      if (a.amount > 0) {
        return (
          <AddonItem
            key={a.id}
            id={a.id}
            name={a.name}
            amount={a.amount}
            price={a.price}
            titles={titles}
            currency={a.currency}
            currencyCode={a.currencyCode}
            onAddonRemove={onAddonRemove}
          />
        );
      }
    });

    return <div className={styles.addons}>{toRender}</div>;
  }
}

AddonsList.defaultProps = {
  addons: []
};

AddonsList.propTypes = {
  addons: PropTypes.array,
  titles: PropTypes.object,
  onAddonRemove: PropTypes.func
};

export default AddonsList;



// WEBPACK FOOTER //
// ./src/components/Cart/Rooms/Room/RoomBody/AddonsList/AddonsList.js